<style  scoped>



</style>

<template>

<div class="c-loader o-wrapper--valign u-fixed u-pos-tl u-viewport-fit-h u-fit-w u-bg--brand-dark">

    <div class="u-absolute u-pos-center u-force-inline">


            <img src="/static/HeadImages/Logo--salameh--small.png" class="c-loader-intro__logo__ribbon__AV__Inside  u-disp--0@sm">

      <!--    <div style="float:left;">
            <img src="../../assets/medias/images/Chevron-fluid-mark-Anim.svg" class="c-loader-intro__logo__ribbon__Inside">
          </div>-->

    </div>
</div>

</template>

<script>

export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        isActive: {
            type: Boolean,
            default: !1
        }
    },
    watch:
    {
        isActive: "onActiveChange"
    },
    methods:
    {
        onActiveChange: function()
        {

           this.debug&&console.log("On Active Changed app Loader");
            var t = this;
            this.isActive ? (this.$el.style.display = "block", setTimeout(function() {
                t.onTransitionLoop(), t.$el.classList.add("is-active")  }, 50)) : (this.$el.classList.remove("is-active"), setTimeout(function() {
                t.$el.style.display = "none"
            }, 500))
        },
        onTransitionLoop: function()
        {
            var t = this;
            clearTimeout(e);
            this.$el.classList.add("is-loop");
            var e = setTimeout(function() {
                t.$el.classList.remove("is-loop")
            }, 1500)
        }
    }
}

</script>
